<template>
  <v-card-text>
    <v-container>
      <!-- USER NAME -->
      <v-row>
        <v-text-field
          :model-value="profileInfo.userName"
          label="User Name"
          variant="outlined"
          readonly
        >
        </v-text-field>
      </v-row>

      <!-- IDENTITY TYPE -->
      <v-row>
        <v-text-field
          :model-value="profileInfo.identityValue"
          :label="
            profileInfo.identityType === 'ROLLNUMBER'
              ? 'Roll Number'
              : 'Email Id'
          "
          variant="outlined"
          readonly
        >
        </v-text-field>
      </v-row>
      <v-row>
        <v-text-field
          :model-value="profileInfo.mobileNumber"
          label="Primary Mobile Number"
          variant="outlined"
          readonly
        >
        </v-text-field>
      </v-row>
      <div style="color: red; font-size: 10px;">*This number will be used for OTP login. If you want to change your primary number, <a href="https://forms.gle/YFqYT4xd8dfSbEgu9" target="_blank">click here</a>.</div>
    </v-container>

    <!-- IF IN ORGANIZATION -->
    <template v-if="profileInfo.organization">
      <p>
        You are currently connected to
        {{ profileInfo.organization.organizationName }} system
      </p>
      <br />
      <v-container>
        <!-- NAME -->
        <v-row>
          <v-text-field
            :model-value="profileInfo.organization.name"
            label="Name"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- ROLL NUMBER -->
        <v-row>
          <v-text-field
            label="Roll Number"
            :model-value="profileInfo.organization.rollNumber"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- ACTIVATION KEY -->
        <v-row>
          <v-text-field
            label="Activation Key"
            :model-value="profileInfo.organization.activationToken"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- EMAIL -->
        <v-row>
          <v-text-field
            label="Email"
            :model-value="profileInfo.organization.email"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- STATUS -->
        <v-row>
          <v-text-field
            label="Status"
            :model-value="
              profileInfo.organization.status ? 'Active' : 'Inactive'
            "
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- CLASS -->
        <v-row>
          <v-text-field
            label="Class"
            :model-value="profileInfo.organization.batch"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- GRADE -->
        <v-row>
          <v-text-field
            label="Grade"
            :model-value="profileInfo.organization.course"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>

        <!-- SCHOOL -->
        <v-row>
          <v-text-field
            label="School"
            :model-value="profileInfo.organization.center"
            variant="outlined"
            readonly
          >
          </v-text-field>
        </v-row>
        <div v-if="!!referralData">
          <v-row >
            <v-text-field
              label="Referral Code"
              :model-value="referralData.referral_code"
              variant="outlined"
              readonly
            >
            </v-text-field>
          </v-row>
          <v-row>
            <v-text-field
            label="Referral Amount"
            :model-value="referralData.referral_amount"
            variant="outlined"
            readonly
            >
            </v-text-field>
          </v-row>
          <v-row>
            <v-text-field
            label="Referral Percentage"
            :model-value="referralData.referral_percentage + '%'"
            variant="outlined"
            readonly
            >
            </v-text-field>
            <div style="font-size: 10px;">* This referral code can be used to gain points. Refer your friend and get points worth  {{referralData.referral_percentage}}% of the payment in your account which can be redeemed. Redemption module will be launched soon</div>
          </v-row>
        </div>
      
      </v-container>
    </template>
  </v-card-text>
</template>

<script>
import { mapState } from "vuex";
import { referralAPI } from "@/services/apiService";
export default {
  data: () => ({
    referralData: null
  }), 
  async created() {
    this.referralData = await this.fetchReferralData(this.$store.state.profileInfo.organization.rollNumber).then(res => res.data)
  },  
  computed: {
      ...mapState(["profileInfo"]),
  },
  methods: {
    fetchReferralData(rollNumber) {
      return referralAPI(rollNumber)
    }
  }
};
</script>

<style scoped>
</style>